import Slider from '@material-ui/core/Slider';
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip, withStyles } from "@material-ui/core";
import ContentsAltitudeSlider from "./ContentsAltitudeSlider";
import {
  altitudeState,
  altitudeVisibleState,
  rangeAltitudeEnableState,
} from "../../store/MapAltitudeState";
import { useRecoilValue, useSetRecoilState } from "recoil";

const useStyles = makeStyles({
  root: {
    display: 'flex',
    height: 200,
    pointerEvents: 'auto'
  },
  altitudeWrapper: {
    border: '1px solid rgba(38,38,238,0.3)',
    backgroundColor: 'rgba(200,200,238,0.7)',
    paddingTop:8
  }
});
const marks = [
  {
    value: 0,
    label: 'SFC',
  },
  {
    value: 100,
    label: 'FL100',
  },
  {
    value: 200,
    label: 'FL200',
  },
  {
    value: 300,
    label: 'FL300',
  },
  {
    value: 400,
    label: 'FL400',
  },
  {
    value: 500,
    label: 'FL500',
  },
  {
    value: 530,
    label: '',
  },
];

const valueLabelFormat = (value) => {
  let fl;
  if(value === 0) {
    fl = 'SFC';
  } else {
    fl = `FL${('000' + value).slice(-3)}`;
  }
  return fl;
};
const VerticalRangeSlider = withStyles(theme => ({
  marked: {
    marginRight: "initial!important",
    marginLeft: 40
  },
  markLabel: {
    right: "25px",
    left: "initial!important"
  },
  mark: {opacity:0},
  markActive: {opacity:0},
  markLabelActive: {
    color: '#022466'
  }
}))(Slider);

const AltitudeSlider = () => {
  const setAltitude = useSetRecoilState(altitudeState);
  const altitudeVisible = useRecoilValue(altitudeVisibleState);
  const rangeAltitudeEnable = useRecoilValue(rangeAltitudeEnableState);
  const classes = useStyles();

  const handleChangeCommitted = (_, altitude) => {
    setAltitude([...altitude]);
  };

  const style = {display: altitudeVisible ? 'flex' : 'none'};

  return (
    <div className={classes.altitudeWrapper} style={style}>
      <div className={classes.root}>
        <VerticalRangeSlider
          disabled={!rangeAltitudeEnable}
          orientation="vertical"
          defaultValue={[0, 530]}
          max={530}
          min={0}
          step={10}
          aria-labelledby="vertical-slider"
          valueLabelFormat={valueLabelFormat}
          marks={marks}
          ValueLabelComponent={ValueLabelComponent}
          onChangeCommitted={handleChangeCommitted}
        />
        <ContentsAltitudeSlider
          max={530}
          min={0}
          step={10}
        />
      </div>
    </div>
  );
};

export default AltitudeSlider;

const ValueLabelComponent = (props) => {
  const { children, open, value } = props;

  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}